<script setup lang="ts">
import type { Faq } from '~/types'

const { data } = await useFetch('/api/faqs')
const faqs = computed(() => (data.value?.faqs || []) as Faq[])
</script>

<template>
  <section id="faq" class="bg-slate-50 dark:bg-slate-950 border-slate-200">
    <UContainer class="py-14 md:py-20">
      <div class="max-w-2xl">
        <h2 class="text-2xl font-semibold text-slate-900 dark:text-white md:text-3xl">
          FAQ
        </h2>
        <p class="mt-3 text-slate-600 dark:text-slate-300">
          Dubbi comuni prima di iniziare.
        </p>
      </div>

      <div class="mt-10 grid gap-6 lg:grid-cols-2">
        <UCard
          v-for="faq in faqs"
          :key="faq.id"
          class="rounded-3xl border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950"
        >
          <template #header>
            <p class="text-sm font-semibold text-slate-900 dark:text-white">
              {{ faq.question }}
            </p>
          </template>
          <p class="text-sm text-slate-600 dark:text-slate-300">
            {{ faq.answer }}
          </p>
        </UCard>
      </div>
    </UContainer>
  </section>
</template>

<style scoped>

</style>
